import { DateRange, TimeUnit } from '@cast/shared-types';
import { getRangeLength } from '@cast/utils';

import { DataGranularity } from 'types/cost-report';

export const getCostReportGranularity = (range: DateRange): DataGranularity => {
  const daysInRange = getRangeLength(range, 'days');

  let step = 1;
  let unit: TimeUnit = 'hour';

  if (daysInRange > 31) {
    unit = 'day';
  }

  if (daysInRange < 10) {
    step = 5;
    unit = 'minutes';
  }

  return { step, unit };
};
